import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'
import main from '@/views/portal/Main'
import Flow from '@views/info/flow.vue'
/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
  {
    path: '/',
    name: 'dashboard',
    component: TabLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/analysis',
    children: [
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: BlankLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/ProvinceLogin')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/user/register/Register')
      },
      {
        path: 'agreement',
        name: 'agreement',
        title: '用户协议',
        component: () => import('@/views/user/register/Agreement')
      },
      {
        path: 'expertRegister',
        name: 'expertRegister',
        component: () => import('@/views/user/register/ExpertRegister')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import('@/views/user/register/RegisterResult')
      },
      {
        path: 'resetPwd',
        name: 'resetPwd',
        component: () => import('@/views/user/alteration/resetPwd')
      },
      {
        path: 'alteration',
        name: 'alteration',
        component: () => import('@/views/user/alteration/Alteration')
      },
    ]
  },

  {
    path: '/ebid',
    component: BlankLayout,
    redirect: '/ebid/TmBidProjectFlow',
    hidden: true,
    children: [
      {
        path: 'tmBidProjectFlow',
        name: 'tmBidProjectFlow',
        meta: { title: '招标项目流程' },
        component: () => import('@/views/ebid/TmBidProjectFlow')
      },
    ]
  },
  {
    path: '/guarantee',
    component: BlankLayout,
    redirect: '/guarantee/outOrder',
    hidden: true,
    children: [
      {
        path: 'outOrder',
        name: 'outOrder',
        meta: { title: '电子保函订单页面' },
        component: () => import('@/views/guarantee/outOrder')
      },
      {
        path: 'guaranteeList',
        name: 'guaranteeList',
        meta: { title: '机构列表页面' },
        component: () => import('@/views/guarantee/guaranteeList')
      },
    ]
  },
  {
    path: '/info',
    component: BlankLayout,
    redirect: '/info/flow',
    hidden: true,
    children: [
      {
        path: 'flow',
        name: 'flow',
        meta: { title: '信息页面' },
        component: Flow
      },
    ]
  },
  {
    path: '/iebid',
    component: BlankLayout,
    redirect: '/iebid/ebidOpenHall',
    hidden: true,
    children: [
      {
        path: 'tmBidOpenHall',
        name: 'tmBidOpenHall',
        meta: { title: '开标大厅' },
        component: () => import('@/views/ebid/ebidopen/ebidOpenHall')
      },
    ]
  },
  {
    path: '/iebid',
    component: BlankLayout,
    redirect: '/ebid/todayEvalProcess',
    hidden: true,
    children: [
      {
        path: 'todayEvalProcess',
        name: 'todayEvalProcess',
        meta: { title: '今日项目管理评标过程' },
        component: () => import('@/views/ebid/ebidopen/todayEvalProcess')
      },
    ]
  },

  {
    path: '/bobidopen',
    component: BlankLayout,
    redirect: '/bobidopen/openHome',
    hidden: true,
    children: [
      {
        path: 'openHome',
        name: 'openHome',
        meta: { title: '开标系统首页' },
        component: () => import('@/views/bobidopen/openHome')
      },
      {
        path: 'purchaseOpenHome',
        name: 'purchaseOpenHome',
        meta: { title: '企业采购开标子系统首页' },
        component: () => import('@/views/bobidopen/PurchaseOpenHome')
      },
      {
        path: 'purchaseEvalHome',
        name: 'purchaseEvalHome',
        meta: { title: '企业采购评标子系统首页' },
        component: () => import('@/views/bobideval/PurchaseEvalHome')
      },
      {
        path: 'conditionEnterprise',
        name: 'conditionEnterprise',
        meta: { title: '查看符合条件企业' },
        component: () => import('@/views/bobidopen/modules/ConditionEnterprise')
      },
      {
        path: 'committee',
        name: 'committee',
        meta: { title: '组建专家委员会' },
        component: () => import('@/views/bobidopen/modules/Committee')
      }
    ]
  },

  {
    path: '/bobidappraise',
    component: BlankLayout,
    redirect: '/bobidappraise/appraiseHome',
    hidden: true,
    children: [
      {
        path: 'appraiseHome',
        name: 'appraiseHome',
        meta: { title: '评标子系统首页' },
        component: () => import('@/views/bobidappraise/appraiseHome')
      },
      {
        path: 'bidProjectFile',
        name: 'bidProjectFile',
        meta: { title: '评标子系统招标书展示' },
        component: () => import('@/views/bobideval/BidProjectFile')
      },
      {
        path: 'checkWeightAnalysis',
        name: 'checkWeightAnalysis',
        meta: { title: '查重分析' },
        component: () => import('@/views/bobidappraise/modules/CheckWeightAnalysis')
      },
      {
        path: 'checkWeightAnalysisFile',
        name: 'checkWeightAnalysisFile',
        meta: { title: '查重分析' },
        component: () => import('@/views/bobidappraise/modules/CheckWeightAnalysisFile')
      }
    ]
  },
  //产权土矿
  {
    path: '/earthmine',
    component: BlankLayout,
    redirect: '/earthmine/EmBidProjectFlow',
    hidden: true,
    children: [
      {
        path: 'emBidProjectFlow',
        name: 'emBidProjectFlow',
        meta: { title: '项目流程' },
        component: () => import('@/views/earthmine/EmBidProjectFlow')
      },
    ]
  },
  {
    path: '/propertyright',
    component: BlankLayout,
    redirect: '/propertyright/PrBidProjectFlow',
    hidden: true,
    children: [
      {
        path: 'prBidProjectFlow',
        name: 'prBidProjectFlow',
        meta: { title: '项目流程' },
        component: () => import('@/views/propertyright/PrBidProjectFlow')
      },
      {
        path: 'prOpenBiddingInfo',
        name: 'prOpenBiddingInfo',
        meta: { title: '竞价' },
        component: () => import('@/views/propertyright/PrOpenBiddingInfo')
      },
    ]
  },
  //以下为门户的路由
  {
    path: '',
    redirect: '/portal/home'
  },
  {
    path: '/portal',
    name: 'portal',
    component: main,
    meta: { title: '首页' },
    redirect: '/portal/main',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/portal/Home')
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/portal/News')
      },
      {
        path: 'newsSearch',
        name: 'newsSearch',
        component: () => import('@/views/portal/NewsSearch')
      },
      {
        path: 'newsInfo',
        name: 'newsInfo',
        component: () => import('@/views/portal/NewsInfo')
      },
      {
        path: 'tender',
        name: 'tender',
        component: () => import('@/views/portal/Tender')
      },
      {
        path: 'oldPlatform',
        name: 'oldPlatform',
        component: () => import('@/views/portal/OldPlatform')
      },
      {
        path: 'tenderService',
        name: 'tenderService',
        component: () => import('@/views/portal/TenderService')
      },
      {
        path: 'bidOpen',
        name: 'bidOpen',
        component: () => import('@/views/portal/BidOpen')
      },
      {
        path: 'tenderInfo',
        name: 'tenderInfo',
        component: () => import('@/views/portal/TenderInfo')
      },
      {
        path: 'oldPlatformInfo',
        name: 'oldPlatformInfo',
        component: () => import('@/views/portal/OldPlatformInfo')
      },
    ]
  }

]
